import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';

@Injectable()
export class MarketDataDetailsService {
  private marketDataObj: any;
  private marketDataFilterObj: any;
  private userFilteredDataObj: any;
  private dataStream = new BehaviorSubject(null);
  private filterDataStream = new BehaviorSubject(null);

  dataSource = this.dataStream.asObservable();
  filterDataSource = this.filterDataStream.asObservable();

  constructor() {
    this.marketData(null);
  }

  // Set observable marketData
  marketData(message: any) {
    this.dataStream.next(message);
  }

  // Set observable marketData filter
  marketDataFilter(filterApplied: any) {
    this.filterDataStream.next(filterApplied);
  }

  // getMarketData
  getMarketData() {
    return this.marketDataObj;
  }

  // setMarketData
  setMarketData(marketDataObj: any) {
    this.marketDataObj = marketDataObj;
  }

  // getMarketDataFilter
  getMarketDataFilter() {
    return this.marketDataFilterObj;
  }

  // setMarketDataFilter
  setMarketDataFilter(marketDataFilterObj: any) {
    this.marketDataFilterObj = marketDataFilterObj;
  }

  // getUserFilteredData
  getUserFilteredData() {
    return this.userFilteredDataObj;
  }

  // setUserFilteredData
  setUserFilteredData(userFilteredDataObj: any) {
    this.userFilteredDataObj = userFilteredDataObj;
  }

  fetchUserFilteredData(bookmarkedItem) {
    let userFilteredData;
    if (bookmarkedItem.bookmarkMarketData && bookmarkedItem.bookmarkMarketData.length > 0) {
      userFilteredData = bookmarkedItem.bookmarkMarketData[0].marketDataFilter;
      return {
        countryId: userFilteredData.countryId ? userFilteredData.countryId : [],
        employeeSizeId: userFilteredData.employeeSizeId ? userFilteredData.employeeSizeId : [],
        geographyId: userFilteredData.geographyId ? userFilteredData.geographyId : [],
        industryId: userFilteredData.industryId ? userFilteredData.industryId : [],
        itBudgetId: userFilteredData.itBudgetId ? userFilteredData.itBudgetId : [],
        jobTitleId: userFilteredData.jobTitleId ? userFilteredData.jobTitleId : [],
        lineOfBusinessId: userFilteredData.lineOfBusinessId ? userFilteredData.lineOfBusinessId : [],
        globalRevenueId: userFilteredData.globalRevenueId ? userFilteredData.globalRevenueId : [],
        subTechDomainId: userFilteredData.subTechDomainId ? userFilteredData.subTechDomainId : []
      };
    } else {
        return{
          countryId: [],
          employeeSizeId: [],
          geographyId: [],
          industryId: [],
          itBudgetId: [],
          jobTitleId: [],
          lineOfBusinessId: [],
          globalRevenueId: [],
          subTechDomainId: []
        };
    }
  }

  // Populate Market Data Filter Selection
  populateMarketDataFilterSelection(userFilterList, userFilteredData) {
    const filterKeyMap: any = {
      "country": "countryId",
      "employeeSize": "employeeSizeId",
      "geography": "geographyId",
      "industry": "industryId",
      "itBudget": "itBudgetId",
      "jobTitle": "jobTitleId",
      "lineOfBusiness": "lineOfBusinessId",
      "revenue": "globalRevenueId",
      "solution": "subTechDomainId"
    };
    _.map(userFilterList.solution, filterObj => {
      filterObj.status = false;
      return filterObj;
    });
    _.forEach(userFilterList, function(value, key) {
      userFilterList[key] = _.map(value, function(element) {
        if (_.includes(userFilteredData[filterKeyMap[key]], element.id)) {
          return _.extend({}, element, {status: true});
        } else {
          return _.extend({}, element, {status: false});
        }
      });
    });
    return userFilterList;
  }

  // Reset Market Data Filter
  resetMarketDataFilterSelection(userFilterList) {
    _.forEach(userFilterList, function(value, key) {
      userFilterList[key].forEach(function(el) { el.status = false; });
    });
    return userFilterList;
  }

  // Get Applied Filters
  getAppliedFilters(userFilterList) {
    return {
      country: _.filter(userFilterList.country, {status: true}),
      employeeSize: _.filter(userFilterList.employeeSize, {status: true}),
      geography: _.filter(userFilterList.geography, {status: true}),
      industry: _.filter(userFilterList.industry, {status: true}),
      itBudget: _.filter(userFilterList.itBudget, {status: true}),
      jobTitle: _.filter(userFilterList.jobTitle, {status: true}),
      lineOfBusiness: _.filter(userFilterList.lineOfBusiness, {status: true}),
      revenue: _.filter(userFilterList.revenue, {status: true}),
      solution: _.filter(userFilterList.solution, {status: true}),
    };
  }

  // check Filters Applied
  checkFiltersApplied(userAppliedFilterList) {
    return (
      _.isEmpty(userAppliedFilterList.country) &&
      _.isEmpty(userAppliedFilterList.employeeSize) &&
      _.isEmpty(userAppliedFilterList.geography) &&
      _.isEmpty(userAppliedFilterList.industry) &&
      _.isEmpty(userAppliedFilterList.itBudget) &&
      _.isEmpty(userAppliedFilterList.jobTitle) &&
      _.isEmpty(userAppliedFilterList.lineOfBusiness) &&
      _.isEmpty(userAppliedFilterList.revenue) &&
      _.isEmpty(userAppliedFilterList.solution)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/market-data-details.service.ts